import React from 'react'

const IncomingTransfers = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Incoming Transfers</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Stock Transfers</li>
            <li className="breadcrumb-item active">Incoming Transfers</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Incoming Transfers</h5>
                <p>Incoming transfers content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default IncomingTransfers

